import { Puzzle } from '../types';

export const PUZZLES: Record<string, Puzzle> = {
  blackboard_cipher: {
    id: 'blackboard_cipher',
    title: '黒板の暗号',
    description: '黒板に書かれた数字を五十音表で解読せよ。\n\n「5-2  11-4  9-5」\n\n五十音表（濁音行を含む）:\nあいうえお  (1行目)\nかきくけこ  (2行目)\nさしすせそ  (3行目)\nたちつてと  (4行目)\nなにぬねの  (5行目)\nはひふへほ  (6行目)\nまみむめも  (7行目)\nやゆよ     (8行目)\nらりるれろ  (9行目)\nわをん     (10行目)\nがぎぐげご  (11行目)\nざじずぜぞ  (12行目)\nだぢづでど  (13行目)\nばびぶべぼ  (14行目)\nぱぴぷぺぽ  (15行目)\n\n「行-列」の形式で、五十音表の文字を読み取ろう。',
    type: 'cipher',
    roomId: 'classroom',
    hints: [
      '五十音表の5行目は「なにぬねの」。5行目の2番目は？',
      '11行目は濁音「がぎぐげご」。11行目の4番目は？',
      '5-2=「に」、11-4=「げ」、9-5=「ろ」。つなげると……',
    ],
    solution: 'にげろ',
    storyText: '「逃げろ」……誰かの警告？\nロッカーの番号のヒントかもしれない。暗号の行番号を思い出せ……5、11、9……',
  },

  locker_search: {
    id: 'locker_search',
    title: 'ロッカー探索',
    description: 'ロッカーを調べよう。番号は1〜30まである。\n黒板の暗号のヒントを思い出せ。\n\n暗号「5-2  11-4  9-5」の行番号……\n5、11、9\nこの数字をどう使う？\n\nどのロッカーを開ける？（番号を入力）',
    type: 'search',
    roomId: 'classroom',
    hints: [
      '暗号の行番号は 5, 11, 9 だった',
      '足してみよう: 5 + 11 + 9 = ?',
      '答えは25。25番のロッカーを開けよう',
    ],
    solution: '25',
    reward: 'staffroom_key',
    storyText: '25番のロッカーを開けると、中に鍵と紙切れが入っていた。\n鍵には「職員室」と刻まれている。\n紙切れには「ここから出して」と震える字で書かれていた。',
  },

  drawer_logic: {
    id: 'drawer_logic',
    title: '引き出しの論理パズル',
    description: '5つの引き出し（左から A, B, C, D, E）がある。\n一つだけに重要な書類が入っている。\n\nメモの条件：\n① 「Aの右隣にBはない」→ BはAのすぐ右にはない\n② 「Cは端にある」→ CはAかEの位置\n③ 「目的のものはCの隣にある」\n④ 「DはBより左にある」\n\n実際の並びはA,B,C,D,Eではなく、条件を満たす配置を考え、\n「目的のもの」が入っている引き出しの番号（左から1〜5）を答えよ。',
    type: 'logic',
    roomId: 'staffroom',
    hints: [
      '条件②から、Cは1番目か5番目の位置にある',
      '条件③から、目的のものはCの隣、つまり2番目か4番目にある',
      'Cが1番目(左端)なら目的のものは2番目。Cが5番目(右端)なら4番目。条件④でDはBより左。条件①でAの右隣にBは来ない。Cが左端の場合を考えると…答えは2番目の引き出し',
    ],
    solution: '2',
    reward: 'music_room_key',
    storyText: '2番目の引き出しから音符の形のキーホルダーがついた鍵が見つかった。\n鍵と一緒に、ある生徒の指導記録が入っていた。\n「水無月詩織 - いじめの相談あり。対応中……」\n記録はそこで途切れている。',
  },

  medicine_dial: {
    id: 'medicine_dial',
    title: '薬棚のダイヤルロック',
    description: '4桁のダイヤルロックを解除せよ。\n\nカルテの情報：\n日付: XX月03日\n体温: XX.6℃\n\n一部の数字が汚れて読めない……。\n保健室の机にある控えカルテを見れば、\n欠けている情報がわかるかもしれない。\n\n4桁の暗証番号を入力せよ。',
    type: 'combination',
    roomId: 'infirmary',
    hints: [
      '保健室の机のカルテ控えを確認しよう',
      'カルテ控え：09月03日、体温36.6℃',
      '汚れて読めない部分＝月(09)と体温の整数部(36)→ 0936',
    ],
    solution: '0936',
    reward: 'medicine_bottle',
    storyText: '薬棚が開いた。中には空の安定剤の瓶と、小さなメモ。\n「毎日飲んでいたのに、効かなくなった」\n詩織は精神的に追い詰められていたようだ……。',
  },

  roster_search: {
    id: 'roster_search',
    title: '生徒名簿の調査',
    description: '2年B組の生徒名簿を調べよう。\n\n名簿を開くと、一人の名前に赤い線が引かれている。\n「水無月 詩織（みなづき しおり）」\n\n出席番号: 15\n部活: 音楽部（ピアノ）\n備考欄: 「長期欠席→退学」※赤字で追記「死亡」\n\n名簿の最後のページに、担任のメモが挟まっている。\n「音楽室のピアノ……彼女の居場所だった」\n\nこの情報を記憶しておこう。（「確認」と入力）',
    type: 'search',
    roomId: 'staffroom',
    hints: [
      '「確認」と入力するだけでよい',
    ],
    solution: '確認',
    reward: 'student_roster',
    storyText: '水無月詩織。音楽部でピアノを弾いていた少女。\nいじめにより長期欠席の後、退学扱いに。\nそして……「死亡」という赤い文字。\n\nこの学校で、何があったんだ……？',
  },

  piano_sequence: {
    id: 'piano_sequence',
    title: 'ピアノの旋律',
    description: '破れた楽譜を3つ集めて正しい順序で弾こう。\n\n持ち物の楽譜を確認し、\n3つの断片を正しくつなげて旋律を完成させよう。\n\n（音名をスペース区切りで入力。例: ド ミ ソ）',
    type: 'sequence',
    roomId: 'music_room',
    hints: [
      '楽譜の断片を3つすべて集めただろうか？持ち物から確認しよう',
      '1枚目: ド ミ ソ → 2枚目: ド ミ ソ → 3枚目: ラ シ ド',
      'すべて繋げると9音になる。スペース区切りで入力しよう',
    ],
    solution: ['ド', 'ミ', 'ソ', 'ド', 'ミ', 'ソ', 'ラ', 'シ', 'ド'],
    reward: 'floor3_key',
    storyText: '正しい旋律を弾くと、ピアノの中から鍵が落ちてきた。\n「3F」と刻まれている。\n\n……弾き終わった瞬間、ピアノの蓋が勝手に閉じた。\n微かに、拍手のような音が聞こえた気がする。',
  },

  bookshelf_morse: {
    id: 'bookshelf_morse',
    title: '本棚のモールス信号',
    description: '本の背表紙の色パターンを解読せよ。\n\n赤赤赤青 ― 赤青赤赤 ― 赤赤赤 ― 青青\n\n赤＝「・」 青＝「ー」として変換表で解読しよう。\n\n4つのグループを変換表で解読し、\n答えをひらがなで入力せよ。',
    type: 'cipher',
    roomId: 'library',
    hints: [
      '赤＝「・」、青＝「ー」に置き換えてみよう',
      '4つのグループ: ・・・ー / ・ー・・ / ・・・ / ーー を変換表で調べよう',
      '答えは4文字のひらがな。誰かの叫びが聞こえる……',
    ],
    solution: 'たすけて',
    storyText: '「たすけて」……詩織の声なき叫びがここにも残されていた。\n\n本棚の裏を覗くと、さらに日記の断片が見つかるかもしれない。',
  },

  diary_misdirect: {
    id: 'diary_misdirect',
    title: '開かれたノート',
    description: '閲覧机の上のノートを読む。\n\n「犯人はAだ。Aがすべてを仕組んだ。\nAが詩織を追い詰めた。\nAが彼女の持ち物を隠した。\nAがクラス全員を扇動した。\n\nでも……Aは私だ。\nこのノートを書いている、私自身がAだ。\n\n……いや、違う。\n本当の罪は、見ていたのに何もしなかったBだ。\nBは知っていた。全部知っていたのに、\n目を逸らした。\n\nB、お前は誰だ？」\n\nこのノートは重要な伏線だ。（「読了」と入力）',
    type: 'misdirect',
    roomId: 'library',
    hints: [
      '「読了」と入力するだけでよい。内容をよく覚えておこう。',
    ],
    solution: '読了',
    storyText: '「B」とは誰のことだろう。\n\n……まさか。\n\n頭の奥が、ズキリと痛んだ。',
    isOptional: false,
  },

  element_puzzle: {
    id: 'element_puzzle',
    title: '元素記号パズル',
    description: '壁の元素周期表で赤丸がついた元素：\n\nTi（チタン）→ ち\nIr（イリジウム）→ い\nNo（ノーベリウム）→ の\n\nこれらの元素名の頭文字を並べ替えて、\n意味のある日本語の言葉を作れ。\n\nヒント: ち・い・の → ？？？',
    type: 'combination',
    roomId: 'science_lab',
    hints: [
      'ち・い・の を並べ替えよう',
      '「罪」に関連する言葉を考えよう',
      '答えは3文字のひらがな。大切なもの……',
    ],
    solution: 'いのち',
    storyText: '「命（いのち）」\n\n……失われた命。守れなかった命。\nこの理科室で、詩織は何を思っていたのだろう。\n\n実験机の引き出しの奥に、美術室に関するメモが見つかった。\n「5枚の絵を正しく並べれば、真実が見える」',
  },

  painting_order: {
    id: 'painting_order',
    title: '5枚の絵の時系列',
    description: '5枚の絵が壁にバラバラに掛けられている。\n正しい時系列順に並べよ。\n\n① 廊下で少女と別の人物の目が合う。しかし相手はすぐに視線をそらしている\n② 少女が屋上のフェンス越しに空を見上げている。穏やかな表情\n③ 教室で少女が一人座っている。周りのクラスメイトは全員背を向けている\n④ 少女が暗い教室の隅でうずくまっている。机の上に教科書が散乱している\n⑤ 少女が誰かの背中を見つめている。手を伸ばしかけて、止めている\n\n正しい順番を数字で入力せよ（例: 12345）',
    type: 'sequence',
    roomId: 'art_room',
    hints: [
      '日記の断片を集めていれば、物語の流れがわかるはず……',
      '無視される → 期待 → 裏切り → 絶望 → 最後の願い',
      '③ → ⑤ → ① → ④ → ②',
    ],
    solution: '35142',
    reward: 'rooftop_key',
    storyText: '絵を正しい順番に並べ替えると、最後の絵の裏から鍵が落ちた。\n「屋上」と刻まれた、冷たい鍵。\n\n5枚の絵は、水無月詩織の最後の日々を描いていた。\n笑顔から始まり、孤独に終わる物語。\n\n……いや、本当に「終わり」なのか？\nまだ、やるべきことがある気がする。',
  },

  last_words: {
    id: 'last_words',
    title: '最後の言葉',
    description: 'フェンスの前に立つと、風に混じって声が聞こえる。\n\n「……ねえ、覚えてる？\nあの日、廊下で目が合ったよね。\n私、助けてほしかった。\n声をかけてほしかった。\nでも、あなたは……」\n\n選択肢：\n1.「目を逸らした」\n2.「気づかなかった」\n3.「助けたかったけど、できなかった」\n\n番号を入力せよ。',
    type: 'choice',
    roomId: 'rooftop',
    hints: [
      'これまでの物語を振り返ろう。主人公は何をした？',
      'ノートに書かれていた「B」のことを思い出そう',
      '正直に答えることが大切',
    ],
    solution: '1',
    acceptedAnswers: ['1', '2', '3'],
    storyText: '「……そう。あなたは目を逸らしたの。\n知っていたのに。気づいていたのに。\n\n私が毎日泣いていたこと。\n持ち物が隠されていたこと。\n誰にも話せなかったこと。\n\nあなたは、全部知っていた」\n\n記憶が……戻ってくる。\nそうだ。自分は……「傍観者B」だった。',
    choiceStoryTexts: {
      '1': '「……そう。あなたは目を逸らしたの。\n知っていたのに。気づいていたのに。\n\n私が毎日泣いていたこと。\n持ち物が隠されていたこと。\n誰にも話せなかったこと。\n\nあなたは、全部知っていた」\n\n記憶が……戻ってくる。\nそうだ。自分は……「傍観者B」だった。',
      '2': '「……気づかなかった？\n本当に？\n\n毎日泣いていたのに。\n持ち物が隠されていたのに。\nあなたは……見て見ぬふりをしたのよ」\n\n記憶が……戻ってくる。\nそうだ。自分は……本当は気づいていた。',
      '3': '「……助けたかった、か。\nでも、できなかった。\n\nそうかもしれない。\nでも……結果は同じだった」\n\n記憶が……戻ってくる。\nそうだ。自分は……何もできなかった「傍観者B」だった。',
    },
  },

  final_choice: {
    id: 'final_choice',
    title: '最後の選択',
    description: '詩織の手紙を読む。\n\n「あなたへ\n\n恨んでいると思った？\n少しだけ、恨んでいた。\nでも、もう疲れた。\n\n私が本当に欲しかったのは、\nたった一言の「大丈夫？」だった。\n\nもう遅いけれど、\nもしあなたが本当に後悔しているなら、\n一つだけ聞かせて。\n\nあなたは今、何を思っている？」\n\n選択肢：\n1.「ごめんなさい。見て見ぬふりをした自分が許せない」\n2.「もう一度やり直せるなら、必ず声をかける」\n3.「君のことを、忘れない。これからは誰かのために声を上げる」',
    type: 'choice',
    roomId: 'rooftop',
    hints: [
      'どの選択もエンディングに影響する',
      '探索率や日記の収集数も結末に関わる',
      '最も誠実な答えを選ぼう',
    ],
    solution: '3',
    acceptedAnswers: ['1', '2', '3'],
    storyText: '',
    choiceStoryTexts: {
      '1': '「……ごめんなさい、か」\n\n詩織は静かに目を伏せた。\n\n「その言葉を、ずっと待っていた。\nでも……それだけでいいの？\n謝るだけで、何かが変わる？」\n\n風が冷たく吹き抜ける。',
      '2': '「……やり直したい？」\n\n詩織は少し笑った。悲しい笑みだった。\n\n「時間は戻らないよ。\nでも……そう思ってくれたことは、\n少しだけ嬉しい」\n\n風が優しく吹いた。',
      '3': '「……忘れない、か」\n\n詩織は微笑んだ。\n初めて見る、穏やかな笑顔だった。\n\n「ありがとう。\nその言葉が……聞きたかった」\n\n温かい風が吹いた。',
    },
  },
};
